import { useEffect, useRef } from 'react';
import useDatadogRum from './use-datadog-rum.js';
export default function useInit({ enabled, rumInitConfiguration, }) {
    const rum = useDatadogRum();
    const lastRumInitConfiguration = useRef(null);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        if (lastRumInitConfiguration.current === rumInitConfiguration) {
            return;
        }
        lastRumInitConfiguration.current = rumInitConfiguration;
        rum.init(rumInitConfiguration);
    }, [enabled, rum, rumInitConfiguration]);
}
//# sourceMappingURL=use-init.js.map